import TextArea from "./";
import validatable from "../hoc/validatable";

var ValidatableTextArea = function ValidatableTextArea(validators) {
  return validatable(validators)(TextArea);
};

export default ValidatableTextArea;
//# sourceMappingURL=validatable-textarea.js.map